export default __webpack_public_path__ + "static/media/White0004.65484f22.png";